import * as THREE from 'three';
export default class CameraLoader {
    constructor() {
        this.willPlay = null;
        this.video = document.createElement('video');
        this.video.classList.add('veda-video-source');
        this.video.loop = true;
        this.video.muted = true;
        this.video.style.position = 'fixed';
        this.video.style.top = '99.9%';
        this.video.style.width = '1px';
        this.video.style.height = '1px';
        this.video.style.zIndex = '-1';
        document.body.appendChild(this.video);
        this.texture = new THREE.VideoTexture(this.video);
        this.texture.minFilter = THREE.LinearFilter;
        this.texture.magFilter = THREE.LinearFilter;
        this.texture.format = THREE.RGBAFormat;
    }
    enable() {
        this.willPlay = new Promise((resolve, reject) => {
            navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
                this.stream = stream;
                this.video.srcObject = stream;
                this.video.play();
                resolve();
            }, (err) => {
                console.error(err);
                reject();
            });
        });
    }
    disable() {
        this.texture.dispose();
        if (this.willPlay) {
            this.willPlay.then(() => {
                var _a;
                (_a = this.stream) === null || _a === void 0 ? void 0 : _a.getTracks().forEach((t) => t.stop());
            });
        }
    }
}
//# sourceMappingURL=camera-loader.js.map